var map = {
	"./banner/banner_jig.jpg": 6470,
	"./banner/banner_jig_2.jpg": 1293,
	"./banner/banner_talentpool.jpg": 9462,
	"./banner/edunetasia/jobs_banner.jpg": 4560,
	"./banner/edunetasia/skilled_banner.jpg": 3968,
	"./banner/edunetasia/welcome_banner.jpg": 3188,
	"./banner/edunetin/jobs_banner.jpg": 2059,
	"./banner/edunetin/skilled_banner.jpg": 973,
	"./banner/edunetin/welcome_banner.jpg": 6809,
	"./banner/edunetke/jobs_banner.jpg": 5806,
	"./banner/edunetke/skilled_banner.jpg": 1282,
	"./banner/edunetke/welcome_banner.jpg": 8901,
	"./banner/edunetma/jobs_banner.jpg": 9736,
	"./banner/edunetma/skilled_banner.jpg": 5528,
	"./banner/edunetma/welcome_banner.jpg": 2780,
	"./banner/jobs_banner.jpg": 4378,
	"./banner/skilled_banner.jpg": 7934,
	"./banner/slide-1.jpg": 7758,
	"./banner/slide-2.jpg": 1465,
	"./banner/slide-3.jpg": 6092,
	"./banner/slide-4.jpg": 439,
	"./banner/welcome_banner.jpg": 3342,
	"./box-1.jpg": 2855,
	"./box-2.jpg": 2872,
	"./box-3.jpg": 7189,
	"./box-4.jpg": 1566,
	"./flags/ar.svg": 3551,
	"./flags/de.svg": 115,
	"./flags/en.svg": 1215,
	"./flags/es.svg": 6074,
	"./flags/fr.svg": 5506,
	"./flags/it.svg": 185,
	"./flags/pl.svg": 582,
	"./flags/pt.svg": 3326,
	"./flags/ro.svg": 3715,
	"./flags/ru.svg": 1705,
	"./flags/tr.svg": 8588,
	"./flags/uk.svg": 1842,
	"./group-sidebar/development.svg": 4866,
	"./group-sidebar/durations.svg": 3674,
	"./group-sidebar/education.svg": 5499,
	"./group-sidebar/example-job.svg": 6497,
	"./group-sidebar/trend.svg": 972,
	"./immigration-guide.png": 1859,
	"./logo-ABA-work.svg": 2980,
	"./logo-ABA.svg": 5770,
	"./logo-work-talent.svg": 5786,
	"./logo/footer-logo-jig.png": 6044,
	"./logo/header-logo-jig.png": 2060,
	"./logo/logo-he.png": 8683,
	"./logo/logo-jobmatch.svg": 1984,
	"./logo/logo-kh.png": 3247,
	"./logo/logo-ncph.png": 9251,
	"./logo/logo-rhh.png": 8862,
	"./logo/logo-rhh33.png": 6924,
	"./logo/logo-t4a.png": 7005,
	"./logo/logo-wconat.png": 3448,
	"./logo/logo-work-edunet-OLD.png": 3365,
	"./logo/logo-work-edunet.png": 5321,
	"./logo/logo-work-edunetasia.png": 9003,
	"./logo/logo-work-edunetke.png": 2433,
	"./logo/logo-work-edunetma.png": 2547,
	"./logo/logo-work-talenpool.svg": 3632,
	"./photo-placeholder-men.png": 4017,
	"./photo-placeholder-woman.png": 2571,
	"./photo-placeholder.jpg": 4018,
	"./the-essential-guide.png": 1223,
	"./themes/logo-work-talent.svg": 275,
	"./themes/logo-work-talentpool.svg": 813
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;